'use client';

import Link from 'next/link';

/**
 * Modest "Buy now" link that opens the shared checkout popup (useCheckoutPopup)
 * on click — never on its own. Extracted from the converter's PopupCheckout.js
 * so the generator can show the same, deliberately low-key CTA instead of a
 * plain "/pricing" link.
 */
export default function BuyNowLink({
  checkoutUrl,
  onShow,
  className = 'mt-3 text-primary',
  label = 'Buy now',
}) {
  return (
    <Link
      href={checkoutUrl}
      onClick={onShow}
      className={className}
    >
      {label}
      <i className="uil uil-angle-right" />
    </Link>
  );
}
